<div class="header">
  <div class="logo">
    <img src="assets/logo/logo.svg" alt="Sophia Logo" />
  </div>

  <div class="header-right">
    @if(authService.isSelectedMedicalCenter()) {
    <div class="notifications">
      <div class="icon-bell">
        <img src="assets/icons-v2/notification-bell.svg" alt="Notifications" />
      </div>
      <span class="notification-count">1</span>
    </div>
    }

    <div class="profile">
      <img src="assets/avatars/doctor-1.svg" alt="Profile" class="profile-img" />

      <nav>
        <ul class="menu">
          <li class="menu-item">
            <p>
              Hola, {{ userName()?.trim() || '' }}

              @if(!userName()) {
              <mat-spinner diameter="24" class="custom-color"></mat-spinner>
              }

              <img src="assets/icons-v2/arrow-down.svg" alt="Dropdown Arrow" />
            </p>
            <ul class="submenu">
              @for ( item of menuItems; track item.id ) { @if(item.show) {
              <li
                [id]="item.id"
                (click)="item.action()"
                (mouseenter)="mouseInteraction($event, item.id)"
                (mouseleave)="mouseInteraction($event, item.id)"
              >
                <a>
                  <img [src]="iconToShow(item.id)" alt="Perfil" class="link-icon" />
                  {{ item.label }}
                </a>
              </li>
              } }
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
